/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PositionDto } from '../models/PositionDto';
import type { PositionSearchRequestDto } from '../models/PositionSearchRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PositionService {
    /**
     * Search positions by DDO IDs
     * Retrieves positions for the given dispatch delivery order (DDO) IDs from the route service.
     * @param requestBody
     * @returns PositionDto List of positions for the requested DDOs
     * @throws ApiError
     */
    public static positionControllerSearch(
        requestBody: PositionSearchRequestDto,
    ): CancelablePromise<Array<PositionDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/position/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed (ddoIds missing, not array, empty, or contains non-strings)`,
                401: `Unauthorized - Invalid or missing JWT token`,
            },
        });
    }
}
